export default __webpack_public_path__ + "static/media/penpoem-logo.2ad32ef0.png";